import { handleAuth } from './service';

const handleBind = (el, binding) => {
  const type = binding.arg || 'click';
  el[`on${type}`] = async () => {
    const { href = false } = binding.modifiers;
    await handleAuth({ href });
    const isFunction = typeof binding.value === 'function';
    if (isFunction) {
      binding.value();
    } else {
      const { method, params } = binding.value;
      method(params, el);
    }
  };
};

const auth = {
  bind: handleBind,
  update: handleBind,
};

export default auth;
